import { css } from '@emotion/core'

export const clearBorder = css`
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
`
